"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownSelectMixin = void 0;
var _styledComponents = require("styled-components");
var _ComboboxInput = require("../../components/ComboboxInput/ComboboxInput.styles");
var _Input = require("../../components/Input/Input.styles");
var DropdownSelectMixin = function DropdownSelectMixin() {
  return (0, _styledComponents.css)(["", ":not([disabled]),", ":not([disabled]){cursor:pointer;}"], _ComboboxInput.StyledComboboxInput, _Input.StyledInput);
};
exports.DropdownSelectMixin = DropdownSelectMixin;